export default __webpack_public_path__ + "static/media/solvewareLogo.a6b040dc.png";